<template>
  <!-- a-config-provider：汉化ant-design-vue组件 -->
  <a-config-provider :locale="zh_CN">
    <div class="top-box">
      <div class="top-header">
        <!-- <img src="@/assets/logo.png" /> -->
        <div class="logo-box">安全评价人才交流</div>
      </div>
      <router-view></router-view>
      <!-- <div class="new-footer">
        <ul>
          <li>主管单位：中国安全生产协会</li>
          <li>承办单位：中国安全生产协会安全评价工作委员会</li>
          <li>技术支持电话：84285160&nbsp;&nbsp;&nbsp;84287119</li>
          <li>京ICP备10211073号-8</li>
        </ul>
      </div> -->
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data () {
    return {
      zh_CN
    };
  }
};
</script>
<style lang="less" scoped>
@import "./layout.less";
</style>



// WEBPACK FOOTER //
// src/components/ui/Layout.vue